import React, { useCallback, useState } from 'react';
import { useHistory } from 'react-router-dom';

import Popover from '@mui/material/Popover';

import { Message } from '../../types';

import MessageNotificationsList from '../MessageNotificationsList';
import BellIconButton from './BellIconButton';

export interface MessageNotificationsProps {
  unseen: number;
  messages?: Message[];
}

const MessageNotifications = (props: MessageNotificationsProps) => {
  const { messages, unseen } = props;
  const history = useHistory();
  const [anchorEl, setAnchorEl] = useState<HTMLElement>();

  const handleOpenMessages = useCallback((event: React.MouseEvent) => {
    setAnchorEl(event.target as HTMLElement);
  }, []);

  const onCloseMessages = useCallback(() => {
    setAnchorEl(undefined);
  }, []);

  const handleOnViewMore = useCallback(() => {
    if (!messages || !messages.length) {
      return;
    }
    const [message] = messages;
    history.push(`/messages/${message.id}`);
    onCloseMessages();
  }, [history, messages, onCloseMessages]);

  const handleNotificationClick = useCallback(
    (message: Message) => {
      history.push(`/messages/${message.id}`);
      onCloseMessages();
    },
    [history, onCloseMessages]
  );

  return (
    <>
      <BellIconButton unseenNotificationsCount={unseen} totalNotificationsCount={messages?.length || 0} onClick={handleOpenMessages} />
      <Popover
        id="notifications-menu"
        anchorEl={anchorEl}
        keepMounted
        open={!!anchorEl}
        onClose={onCloseMessages}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        marginThreshold={8}
        sx={{ mt: 1 }}
      >
        <MessageNotificationsList messages={messages} onViewMore={handleOnViewMore} onNotificationClick={handleNotificationClick} />
      </Popover>
    </>
  );
};

export default MessageNotifications;
